export default __webpack_public_path__ + "static/media/kitchen3-after2-480w.0936e297.webp";